import React from "react";

type DescriptionListItemProps = {
  label: string;
  value?: React.ReactNode;
};
const DescriptionListItem = ({ label, value }: DescriptionListItemProps) => {
  return (
    <div className="py-5 grid grid-cols-3 gap-4 text-sm">
      <dt className="font-normal text-gray-500">{label}</dt>
      <dd className="mt-1 flex text-gray-900 mt-0 col-span-2">
        {value ? (
          <span className="flex-grow">{value}</span>
        ) : (
          <span className="flex-grow text-gray-300 italic">undefined</span>
        )}
      </dd>
    </div>
  );
};

export default DescriptionListItem;
